module.exports = __webpack_public_path__ + "static/media/intro_line.f34b00a0.png";